/**
 * Bridges the CC modal "Generate" click with the processing hooks.
 *
 * The only job of this state is to keep Camunda polling + content refetch alive
 * during the gap between "POST succeeded" and "child appears in content.items".
 * Once the normal machinery can see the work, the signal self-clears.
 *
 * Keyed on UID — the same identifier Camunda uses for its process variables.
 */

export const SUBTITLE_GENERATION_STARTED = 'SUBTITLE_GENERATION_STARTED';
export const SUBTITLE_GENERATION_CLEARED = 'SUBTITLE_GENERATION_CLEARED';

// After this, stop waiting regardless — protects against stuck Camunda.
export const GENERATION_TIMEOUT_MS = 5 * 60 * 1000;

export const subtitleGenerationStarted = (uid) => ({
  type: SUBTITLE_GENERATION_STARTED,
  uid,
  startedAt: Date.now(),
});

export const subtitleGenerationCleared = () => ({
  type: SUBTITLE_GENERATION_CLEARED,
});

const initialState = { uid: null, startedAt: null };

export default function subtitleGeneration(state = initialState, action = {}) {
  switch (action.type) {
    case SUBTITLE_GENERATION_STARTED:
      return { uid: action.uid, startedAt: action.startedAt };
    case SUBTITLE_GENERATION_CLEARED:
      return initialState;
    default:
      return state;
  }
}
